import { create } from "zustand";
import { useAddToColorCollectionModalStore } from "./add-to-color-collection-modal-store";
import { useEditColorCollectionsStore } from "./edit-color-collections-store";
import { useDeleteAccountModalStore } from "./delete-account-modal-store";
import { useMyStyleModalStore } from "./my-style-modal-store";
import { useProfileImageModalStore } from "./profile-image-modal-store";
import { useMySavedColorsModalStore } from "./my-saved-colors-modal-store";
import { useInviteFriendModalStore } from "./invite-friend-modal-store";

export const useAddSavedColorsToCollectionModalStore = create((set) => ({
  isModalOpen: false,
  getSavedColorsToCollectionUrl: null,
  openModal: (url) => {
    useAddToColorCollectionModalStore.getState().closeModal();
    useEditColorCollectionsStore.getState().closeModal();
    useDeleteAccountModalStore.getState().closeModal();
    useMyStyleModalStore.getState().closeModal();
    useProfileImageModalStore.getState().closeModal();
    useMySavedColorsModalStore.getState().closeModal();
    useInviteFriendModalStore.getState().closeModal();

    set({ isModalOpen: true, getSavedColorsToCollectionUrl: url });
  },
  closeModal: () =>
    set({ isModalOpen: false, getSavedColorsToCollectionUrl: null }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));
